// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// NastaveniaView.jsx — Matrix v2 Nastavenia firmy (ústava 64.x · /nastavenia)
// Composite stránka s tabmi: Firma · Logo · Email · Trinity · Záloha
// Backend: GET/PUT /api/company-settings (key-value úložisko)
import React, { useState, useEffect } from 'react'
import { useDirtyFlag } from '../hooks/useDirtyState.js'   // straz_v2 (28. 9. 2026): rozpísané nastavenia držia stráž odchodu (ústava 53.1.b)
import { COLORS, TYPO, SPACE, RADIUS, SK, hladaj } from '../theme.js'
import { PageHeader, Tabs } from '../components/Ui.jsx'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from '../components/Toast.jsx'
import { useAuth } from '../auth/AuthContext.jsx'
import { useLock } from '../hooks/useLock.js'
import PouzivateliaTab from './PouzivateliaTab.jsx'
import ImportyTab from './ImportyTab.jsx'
import BankaTab from './BankaTab.jsx'
import LogTab from './LogTab.jsx'
import PredkontacieTab from './PredkontacieTab.jsx'
import EmailAccountsTab from './EmailAccountsTab.jsx'
import NarodeninySmsTab from '../components/NarodeninySmsTab.jsx'   // NARODENINY_SMS_V1
import DennikKatalogTab from '../components/DennikKatalogTab.jsx'   // DENNIK_TUK_V1: katalóg Denníka na ťuk (ústava 25.2, 28)
import SpravaAppiekTab from '../components/SpravaAppiekTab.jsx'   // SPRAVA_APPIEK_V1: kto čo vidí v mobilných appkách (Mirko 23. 10. 2026)

const ROLES_SETTINGS = ['admin', 'owner', 'office_manager']

export default function NastaveniaView() {
  const { user } = useAuth()
  const [tab, setTab] = useState(() => { try { return new URLSearchParams(window.location.search).get('tab') || 'firma' } catch (_) { return 'firma' } })   // identita_v1: ?tab=uzivatelia = odkaz z nervovej sústavy

  // P1.4_USELOCK_2026-05-30: globálny lock pre Nastavenia (1 admin upravuje config naraz)
  const { lockInfo, acquired } = useLock(user ? 'nastavenia' : null, 'global', user)
  const isLocked = !acquired && !!lockInfo?.by

  if (!user || !ROLES_SETTINGS.includes(user.role)) {
    return (
      <div style={{ padding: SPACE.xl, color: COLORS.muted }}>
        Nemáš oprávnenie zobraziť Nastavenia (vyhradené pre admin / majiteľ / office).
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <PageHeader title="Nastavenia" subtitle="Firma · Logo · Email · Trinity · Záloha" />
      {/* P1.4_USELOCK_2026-05-30: zámok banner — len 1 admin upravuje Nastavenia naraz */}
      {isLocked && (
        <div style={{ background: '#fef2f2', border: '1px solid #ef4444', borderRadius: RADIUS.md,
          padding: SPACE.md, margin: `${SPACE.md}px 0`, fontSize: TYPO.sizes.sm, color: '#b91c1c' }}>
          Nastavenia práve upravuje <strong>{lockInfo.by}</strong>. Si v <b>read-only režime</b>, kým druhý používateľ skončí.
        </div>
      )}
      <fieldset disabled={isLocked} style={{ border: 'none', padding: 0, margin: 0,
        flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column',
        opacity: isLocked ? 0.6 : 1 }}>
      <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', gap: SPACE.lg }}>
        <Tabs value={tab} onChange={setTab} tabs={[
          { key: 'firma',    label: 'Firma' },
          { key: 'logo',     label: 'Logá' },
          { key: 'vop',      label: 'VOP' },
          { key: 'uzivatelia', label: 'Používatelia & PIN' },
          { key: 'email',    label: 'Email reporty' },
          { key: 'neoemail', label: 'E-mail schránky' },  /* premenované 18.7. — pod NEO e-mail nikto nehľadal správu schránok */
          { key: 'smspredlohy', label: 'SMS predlohy' },
          { key: 'dennik',   label: 'Denník — katalóg' },   // DENNIK_TUK_V1
          { key: 'narodeniny', label: 'Narodeninové SMS' },   // NARODENINY_SMS_V1
          { key: 'posta', label: 'Odoslaná pošta' },
          { key: 'trinity',  label: 'Trinity' },
          { key: 'importy',  label: 'Importy' },
          { key: 'banka',    label: 'Banka' },
          { key: 'predkontacie', label: 'Účtovanie' },
          { key: 'zaloha',   label: 'Záloha & DR' },
          { key: 'log',      label: 'LOG zmien' },
          { key: 'appky',    label: 'Správa appiek' },   // SPRAVA_APPIEK_V1
        ]} />
        {tab === 'firma'   && <FirmaTab />}
        {tab === 'logo'    && <LogoTab />}
        {tab === 'vop'     && <VopTab />}
        {tab === 'uzivatelia' && <PouzivateliaTab />}
        {tab === 'email'   && <EmailTab />}
        {tab === 'neoemail' && <EmailAccountsTab />}
        {tab === 'smspredlohy' && <SmsPredlohyTab />}
        {tab === 'dennik' && <DennikKatalogTab />}   {/* DENNIK_TUK_V1 */}
        {tab === 'narodeniny' && <NarodeninySmsTab />}   {/* NARODENINY_SMS_V1 */}
        {tab === 'posta' && <OdoslanaPostaTab />}
        {tab === 'trinity' && <TrinityTab />}
        {tab === 'importy' && <ImportyTab />}
        {/* fa_banka_v1: Banka je pracovná fronta, nie nastavenie. Globálny zámok Nastavení
            (fieldset disabled) vypínal aj tlačidlá Priradiť — keď mal Nastavenia otvorené
            ktokoľvek iný, platby sa nedali spárovať. Vlastný fieldset to vracia späť. */}
        {tab === 'banka'   && <fieldset disabled={false} style={{ border: 'none', padding: 0, margin: 0 }}><BankaTab /></fieldset>}
        {tab === 'predkontacie' && <PredkontacieTab />}
        {tab === 'zaloha'  && <ZalohaTab />}
        {tab === 'log'     && <LogTab />}
        {tab === 'appky'   && <SpravaAppiekTab />}   {/* SPRAVA_APPIEK_V1 */}
      </div>
      </fieldset>
    </div>
  )
}

// ─── Helper: get/set jedneho settingu ────────────────────────────────────
async function getAllSettings() {
  const r = await fetchAuth('/api/company-settings')
  if (!r.ok) return {}
  const data = await r.json()
  // FIX 2026-06-06: backend vracia OBJEKT {key:value} (nie pole) — logá sa inak nezobrazia
  if (Array.isArray(data)) { const obj = {}; for (const row of data) obj[row.key] = row.value; return obj }
  return (data && typeof data === 'object') ? data : {}
}
async function putSettings(obj) {
  const r = await fetchAuth('/api/company-settings', {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(obj),
  })
  return r.ok
}

const card = {
  background: COLORS.bg, border: `1px solid ${COLORS.line}`,
  borderRadius: RADIUS.lg, padding: SPACE.lg,
}
const inputStyle = {
  width: '100%', padding: '8px 10px',
  border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
  fontSize: TYPO.sizes.sm, background: COLORS.bg, color: COLORS.text,
  boxSizing: 'border-box',
}
const labelStyle = {
  fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
  color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.04em',
  marginBottom: 4, display: 'block',
}

function SettingsField({ label, value, onChange, placeholder, type = 'text' }) {
  return (
    <div>
      <div style={labelStyle}>{label}</div>
      {type === 'textarea' ? (
        <textarea value={value || ''} onChange={e => onChange(e.target.value)}
          placeholder={placeholder} rows={3}
          style={{ ...inputStyle, resize: 'vertical' }} />
      ) : (
        <input type={type} value={value || ''} onChange={e => onChange(e.target.value)}
          placeholder={placeholder} style={inputStyle} />
      )}
    </div>
  )
}

// ─── Tab: FIRMA ──────────────────────────────────────────────────────────
function FirmaTab() {
  const [s, setS] = useState({})
  const [orig, setOrig] = useState({})
  const [busy, setBusy] = useState(false)
  const toast = useToast()

  useEffect(() => {
    getAllSettings().then(d => { setS(d); setOrig(d) })
  }, [])

  const dirty = JSON.stringify(s) !== JSON.stringify(orig)

  async function save() {
    setBusy(true)
    const ok = await putSettings(s)
    setBusy(false)
    if (ok) { toast.success('Uložené'); setOrig(s) }
    else    toast.error('Chyba pri ukladaní')
    return !!ok
  }
  useDirtyFlag(dirty, { key: 'nastavenia-firma', save, discard: () => setS(orig) })   // straz_v2

  function upd(k, v) { setS(prev => ({ ...prev, [k]: v })) }

  // Dočasné zastupovanie na CP — rovnaká podmienka ako v quote_pdf.js: platí, kým je
  // dnešok PRED zadaným dátumom. V deň dátumu je doklad späť na pôvodných údajoch.
  const _dnes = new Date().toLocaleDateString('sv-SE')
  const cpOvAktivny = /^\d{4}-\d{2}-\d{2}$/.test(String(s.cp_contact_until || '')) && _dnes < s.cp_contact_until
  const cpPoslednyDen = cpOvAktivny
    ? new Date(new Date(s.cp_contact_until + 'T00:00:00').getTime() - 86400000).toLocaleDateString('sk-SK')
    : ''

  return (
    <div style={card}>
      <h3 style={{ margin: 0, marginBottom: SPACE.md }}>Firma — KAMIR s.r.o.</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
        <SettingsField label="Názov firmy"     value={s.company_name}    onChange={v => upd('company_name', v)}   placeholder="KAMIR s.r.o." />
        <SettingsField label="IČO"             value={s.company_ico}     onChange={v => upd('company_ico', v)}    placeholder="36191892" />
        <SettingsField label="DIČ"             value={s.company_dic}     onChange={v => upd('company_dic', v)} />
        <SettingsField label="IČ DPH"          value={s.company_ic_dph}  onChange={v => upd('company_ic_dph', v)} />
        <SettingsField label="IBAN"            value={s.company_iban}    onChange={v => upd('company_iban', v)} />
        <SettingsField label="Banka"           value={s.company_bank}    onChange={v => upd('company_bank', v)} />
      </div>
      <div style={{ marginTop: SPACE.md }}>
        <SettingsField label="Adresa firmy"    value={s.company_address} onChange={v => upd('company_address', v)} type="textarea" placeholder="Ulica, mesto, PSČ" />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md, marginTop: SPACE.md }}>
        <SettingsField label="Telefón"         value={s.company_phone}   onChange={v => upd('company_phone', v)} />
        <SettingsField label="Email"           value={s.company_email}   onChange={v => upd('company_email', v)} />
      </div>

      {/* Dočasné zastupovanie na cenových ponukách (Mirko 28.8.) — po zadanom dni sa
          doklad sám vráti k pôvodným údajom, nič sa neprepína ručne. */}
      <div style={{ marginTop: SPACE.lg, paddingTop: SPACE.md, borderTop: `1px solid ${COLORS.line}` }}>
        <div style={{ fontWeight: TYPO.weights.semibold, marginBottom: 4 }}>Dočasný kontakt na cenových ponukách</div>
        <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, marginBottom: SPACE.md, maxWidth: 760 }}>
          Kým nepríde deň „Prepnúť späť dňa", tlačí sa na cenovej ponuke toto meno pri „Vypracoval"
          a toto číslo pri „Telefón" — namiesto autora ponuky a firemného čísla. V ten deň sa doklad
          sám vráti k pôvodným údajom. Skôr to zrušíš vymazaním dátumu. Riadok „Obhliadku vykonal"
          sa nemení — to je záznam o tom, kto obhliadku naozaj robil.
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
          <SettingsField label="Meno"    value={s.cp_contact_name}  onChange={v => upd('cp_contact_name', v)}  placeholder="napr. Ivan Kopeček" />
          <SettingsField label="Telefón" value={s.cp_contact_phone} onChange={v => upd('cp_contact_phone', v)} placeholder="+421 …" />
          <SettingsField label="Prepnúť späť dňa" value={s.cp_contact_until} onChange={v => upd('cp_contact_until', v)} type="date" />
        </div>
        <div style={{ marginTop: SPACE.sm, fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold,
          color: cpOvAktivny ? COLORS.add : COLORS.muted }}>
          {cpOvAktivny
            ? `Aktívne — na ponukách je ${s.cp_contact_name || '(bez mena)'}${s.cp_contact_phone ? ' · ' + s.cp_contact_phone : ''}, naposledy ${cpPoslednyDen}. Potom sa to vráti späť samo.`
            : 'Neaktívne — na ponukách je autor ponuky a firemné číslo.'}
        </div>
      </div>
      <div style={{ marginTop: SPACE.lg, display: 'flex', justifyContent: 'flex-end', gap: SPACE.sm }}>
        <BtnGhost onClick={() => setS(orig)} disabled={!dirty || busy}>Zahodiť zmeny</BtnGhost>
        <BtnAdd onClick={save} disabled={!dirty || busy}>{busy ? 'Ukladám…' : 'Uložiť'}</BtnAdd>
      </div>
    </div>
  )
}

// ─── Tab: LOGÁ ──────────────────────────────────────────────────────────
function LogoTab() {
  const [s, setS] = useState({})
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  useEffect(() => { getAllSettings().then(setS) }, [])

  async function upload(endpoint, file) {
    if (!file) return
    setBusy(true)
    try {
      const fd = new FormData()
      const fieldName = endpoint.split('/').pop().replace(/-/g, '_')
      fd.append(fieldName, file)
      console.warn('[LogoTab] upload', { endpoint, fieldName, fileName: file.name, fileSize: file.size, fileType: file.type })
      const r = await fetchAuth(endpoint, { method: 'POST', body: fd })
      console.warn('[LogoTab] response', r.status, r.headers.get('content-type'))
      if (!r.ok) {
        const text = await r.text().catch(() => '')
        let detail = text
        try { detail = JSON.parse(text).error || text } catch (_) {}
        throw new Error(`HTTP ${r.status}: ${detail || 'bez detailu'}`)
      }
      const result = await r.json().catch(() => null)
      console.warn('[LogoTab] result', result)
      toast.success('Logo nahraté ✓')
      const d = await getAllSettings()
      console.warn('[LogoTab] new settings', d)
      setS(d)
    } catch (e) {
      console.error('[LogoTab] error', e)
      toast.error('Chyba pri uploade: ' + (e.message || e))
    } finally {
      setBusy(false)
    }
  }

  // LOGO_KEY_FIX — slot.key MUSÍ sedieť s DB key v company_settings tabuľke
  // logo, stamp, matrix_logo, matrix_logo_light, matrix_logo_color, app_icon
  const slots = [
    { key: 'logo',             endpoint: '/api/company-settings/logo',              label: 'Logo KAMIR (na PDF, faktúry)' },
    { key: 'stamp',            endpoint: '/api/company-settings/stamp',             label: 'Pečiatka firmy (na PDF)' },
    { key: 'matrix_logo',      endpoint: '/api/company-settings/matrix-logo',       label: 'Logo MATRIX (header)' },
    { key: 'matrix_logo_light',endpoint: '/api/company-settings/matrix-logo-light', label: 'Logo MATRIX svetlé (dark theme)' },
    { key: 'matrix_logo_color',endpoint: '/api/company-settings/matrix-logo-color', label: 'Logo MATRIX farebné' },
    { key: 'matrix_logo_sirka',endpoint: '/api/company-settings/matrix-logo-sirka', label: 'Logo MATRIX na šírku (pätička TP)' },
    { key: 'app_icon',         endpoint: '/api/company-settings/app-icon',          label: 'App icon (mobile/favicon)' },
  ]

  return (
    <div style={card}>
      <h3 style={{ margin: 0, marginBottom: SPACE.md }}>Logá, pečiatka a podpisy</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
        {slots.map(slot => (
          <div key={slot.key} style={{
            padding: SPACE.md, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
            background: COLORS.bgSoft,
          }}>
            <div style={{ ...labelStyle, marginBottom: SPACE.sm }}>{slot.label}</div>
            <div style={{ height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: COLORS.bg, border: `1px dashed ${COLORS.line}`, borderRadius: RADIUS.sm,
              marginBottom: SPACE.sm }}>
              {s[slot.key]
                ? <img src={s[slot.key].startsWith('/') ? s[slot.key] : ('/uploads/' + s[slot.key]) + '?t=' + Date.now()}
                    alt="" style={{ maxHeight: 72, maxWidth: '100%' }} />
                : <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}>— nenahraté —</span>}
            </div>
            <label style={{ display: 'block' }}>
              <span style={{ display: 'inline-block',
                padding: '6px 12px', background: COLORS.nav, color: '#fff',
                borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.sm }}>
                {busy ? 'Nahrávam…' : 'Vybrať súbor…'}
              </span>
              <input type="file" accept="image/*" disabled={busy}
                onChange={e => upload(slot.endpoint, e.target.files?.[0])}
                style={{ display: 'none' }} />
            </label>
          </div>
        ))}
      </div>
      <KatalogyReferencii />
      <PodpisyLudi />
    </div>
  )
}

// ─── Tab: EMAIL ─────────────────────────────────────────────────────────
function EmailTab() {
  const [s, setS] = useState({})
  const [orig, setOrig] = useState({})
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  useEffect(() => { getAllSettings().then(d => { setS(d); setOrig(d) }) }, [])
  const dirty = JSON.stringify(s) !== JSON.stringify(orig)
  function upd(k, v) { setS(prev => ({ ...prev, [k]: v })) }

  async function save() {
    setBusy(true)
    const ok = await putSettings(s)
    setBusy(false)
    if (ok) { toast.success('Uložené'); setOrig(s) }
    else    toast.error('Chyba')
    return !!ok
  }
  useDirtyFlag(dirty, { key: 'nastavenia-email', save, discard: () => setS(orig) })   // straz_v2

  return (
    <div style={card}>
      <h3 style={{ margin: 0, marginBottom: SPACE.md }}>Email reporty</h3>
      <p style={{ marginTop: 0, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
        Trinity každý deň o 7:00 pošle súhrn (nedoplatky, splatné FA, alerty) na túto adresu.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
        <SettingsField label="Adresa pre report"
          value={s.email_report_to} onChange={v => upd('email_report_to', v)}
          placeholder="mirko.kasubjak@kamir.sk" />
        <SettingsField label="Čas odoslania (HH:MM)"
          value={s.email_report_time} onChange={v => upd('email_report_time', v)}
          placeholder="07:00" />
      </div>
      <div style={{ marginTop: SPACE.lg, display: 'flex', justifyContent: 'flex-end', gap: SPACE.sm }}>
        <BtnGhost onClick={() => setS(orig)} disabled={!dirty || busy}>Zahodiť</BtnGhost>
        <BtnAdd onClick={save} disabled={!dirty || busy}>{busy ? 'Ukladám…' : 'Uložiť'}</BtnAdd>
      </div>
    </div>
  )
}

// ─── Tab: TRINITY ──────────────────────────────────────────────────────
function TrinityTab() {
  return (
    <div style={card}>
      <h3 style={{ margin: 0, marginBottom: SPACE.md }}>Trinity AI</h3>
      <p style={{ marginTop: 0, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
        Trinity používa Claude API. Status pozri v Mirkovej memory: <code>~/.claude/projects/.../memory/MEMORY.md</code>
      </p>
      <div style={{ padding: SPACE.md, background: 'rgba(59,130,246,0.06)',
        border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, color: COLORS.nav, fontSize: TYPO.sizes.sm }}>
        Nastavenia API kľúča (ANTHROPIC_API_KEY) sa konfigurujú v <code>.env</code> na serveri.
        Editácia z UI je BLOKOVANÁ z bezpečnostných dôvodov (ústava sek. 53 — secrets nie sú v UI).
      </div>
      <div style={{ marginTop: SPACE.md, fontSize: TYPO.sizes.sm }}>
        <strong>Status:</strong> ak chceš upraviť ANTHROPIC_API_KEY → SSH na server → upraviť <code>/home/generalny/kamir/.env</code> → reštart backendu.
      </div>
    </div>
  )
}

// ─── Tab: ZÁLOHA & DR ──────────────────────────────────────────────────
function ZalohaTab() {
  return (
    <div style={card}>
      <h3 style={{ margin: 0, marginBottom: SPACE.md }}>Záloha & Disaster Recovery</h3>
      <p style={{ marginTop: 0, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
        Stav zálohovacej infraštruktúry (ústava sek. 53 + roadmap DR).
      </p>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
        <tbody>
          <Row k="Server cron (15 min)" v="OK — /home/generalny/kamir-backup.sh — DB snapshot + tar src + uploads + MATRIX_FULL_latest.tar.gz" />
          <Row k="Mac mirror"            v="OK — ~/kamir-backup/ — rsync z LAN, fallback Tailscale" />
          <Row k="claude_memory sync"    v="OK — Mac → server pred každou 15-min zálohou (Mirkove poznámky v archíve)" />
          <Row k="USB záchrana"          v="OK — ~/bin/kamir-usb-backup — pripoj USB „KAMIR_BACKUP“ → spusti → 30s hotovo" />
          <Row k="Off-site (Backblaze)"  v="roadmap — klimatické katastrofy / krádež USB" />
          <Row k="Mac warm standby"      v="roadmap (voliteľne)" />
          <Row k="Recovery runbook"      v="OK — /home/generalny/kamir/RECOVERY.md" />
        </tbody>
      </table>
    </div>
  )
}
function Row({ k, v }) {
  return (
    <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
      <td style={{ padding: '6px 8px', color: COLORS.muted, width: 220 }}>{k}</td>
      <td style={{ padding: '6px 8px' }}>{v}</td>
    </tr>
  )
}


// ── PouzivateliaTab — presunutý do samostatného súboru (PouzivateliaTab.jsx, Mirko 2026-05-26) ──
//   Master-detail + heslo + PIN + práva + admin only (ústava 64.2)


// vop_office_v1: zrozumiteľná správa zo servera (403 = kto smie meniť spoločné VOP)
async function vopChyba(r) {
  const d = await r.json().catch(() => ({}))
  return d.message || d.error || ('server vrátil ' + r.status)
}

// ── VopTab — Editor VOP per remeslo + kategória (sek. 66.5) ─────────
function VopTab() {
  const [trade, setTrade] = useState('spolocne')
  const [category, setCategory] = useState('volitelne')
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [newText, setNewText] = useState('')
  const toast = useToast()

  const TRADES = [
    { key: 'spolocne',   label: 'Spoločné',    hint: 'Pridávajú sa do KAŽDEJ cenovej ponuky' },
    { key: 'omietky',    label: 'Omietky',     hint: 'Len ak je v ponuke omietková položka' },
    { key: 'potery',     label: 'Potery',      hint: 'Len ak je v ponuke poterová položka' },
    { key: 'maliarske',  label: 'Maľovanie',   hint: 'Len ak je v ponuke maliarska položka (zatiaľ prázdne)' },
    { key: 'zateplenie', label: 'Zateplenie',  hint: 'Len ak je v ponuke zateplenie (zatiaľ prázdne)' },
  ]
  // Kategórie per trade — Spoločné má len 'volitelne', ostatné majú 3 podkategórie
  const CATEGORIES = trade === 'spolocne' ? [
    { key: 'volitelne', label: 'Bežné body', numbered: true },
  ] : [
    { key: 'volitelne', label: 'Bežné body',                numbered: true,  hint: 'Tieto body sú číslované 1, 2, 3… v PDF' },
    { key: 'priplatky', label: 'Príplatky',                 numbered: false, hint: 'BEZ čísel v PDF (bullets •) — Mirkov dôraz' },
    { key: 'nemenne',   label: 'Podmienky prípravy podkladu', numbered: false, hint: 'Štruktúrovaný blok (STENY / STAVEBNÁ / POVINNOSTI)' },
  ]

  function nacitaj() {
    setLoading(true)
    fetchAuth(`/api/vop-items?trade=${trade}&category=${category}`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setItems(Array.isArray(d) ? d : []))
      .finally(() => setLoading(false))
  }
  useEffect(nacitaj, [trade, category])

  // Reset category na valid pri zmene trade
  useEffect(() => {
    if (trade === 'spolocne' && category !== 'volitelne') setCategory('volitelne')
  }, [trade])

  async function pridaj() {
    if (!newText.trim()) { toast.error('Text je povinný'); return }
    const max = items.reduce((m, x) => Math.max(m, x.sort_order || 0), 0)
    try {
      const r = await fetchAuth('/api/vop-items', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: newText.trim(), trade, category, sort_order: max + 1, active: 1 }),
      })
      if (!r.ok) throw new Error(await vopChyba(r))   // vop_office_v1: skutočný dôvod namiesto „chyba“
      toast.success('Bod pridaný')
      setNewText('')
      nacitaj()
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  async function uloz(item, changes) {
    try {
      const r = await fetchAuth(`/api/vop-items/${item.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(changes),
      })
      if (!r.ok) throw new Error(await vopChyba(r))   // vop_office_v1: skutočný dôvod namiesto „chyba“
      nacitaj()
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  async function zmaz(id) {
    if (!window.confirm('Zmazať tento bod VOP?')) return
    try {
      const r = await fetchAuth(`/api/vop-items/${id}`, { method: 'DELETE' })
      if (!r.ok) throw new Error(await vopChyba(r))   // vop_office_v1: skutočný dôvod namiesto „chyba“
      toast.success('Zmazané')
      nacitaj()
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  const activeTrade = TRADES.find(t => t.key === trade) || TRADES[0]
  const activeCat = CATEGORIES.find(c => c.key === category) || CATEGORIES[0]

  return (
    <div style={card}>
      <h3 style={{ margin: 0, marginBottom: SPACE.md }}>Editor VOP (Všeobecné obchodné podmienky)</h3>

      {/* STICKY HLAVIČKA — tabs trade + category */}
      <div style={{ position: 'sticky', top: 0, zIndex: 5, background: COLORS.bg, paddingBottom: SPACE.sm }}>
        {/* Tabs trade */}
        <div style={{ display: 'flex', gap: 4, borderBottom: `2px solid ${COLORS.brand}` }}>
          {TRADES.map(t => (
            <button key={t.key} onClick={() => setTrade(t.key)} style={{
              padding: '8px 14px',
              background: trade === t.key ? COLORS.brand : 'transparent',
              color: trade === t.key ? '#fff' : COLORS.muted,
              border: 'none',
              borderRadius: '4px 4px 0 0',
              fontSize: TYPO.sizes.sm,
              fontWeight: trade === t.key ? TYPO.weights.bold : TYPO.weights.normal,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>{t.label}</button>
          ))}
        </div>

        {/* Sub-tabs category */}
        <div style={{ display: 'flex', gap: 4, marginTop: SPACE.sm, flexWrap: 'wrap' }}>
          {CATEGORIES.map(c => (
            <button key={c.key} onClick={() => setCategory(c.key)} style={{
              padding: '5px 12px',
              background: category === c.key ? COLORS.navBg : 'transparent',
              border: `1px solid ${category === c.key ? COLORS.brand : COLORS.line}`,
              borderRadius: RADIUS.full,
              fontSize: TYPO.sizes.xs,
              color: category === c.key ? COLORS.brand : COLORS.muted,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>{c.label}{c.numbered === false && category === c.key ? ' • bez čísel' : ''}</button>
          ))}
        </div>

        {/* Info hláška */}
        <div style={{
          padding: SPACE.sm, marginTop: SPACE.sm,
          background: 'rgba(59,130,246,0.06)', border: '1px solid rgba(59,130,246,0.3)',
          borderRadius: RADIUS.sm, fontSize: TYPO.sizes.xs, color: COLORS.muted,
        }}>
          <strong>{activeTrade.label} → {activeCat.label}:</strong> {activeCat.hint || activeTrade.hint}
        </div>
      </div>

      {/* Pridať bod */}
      <div style={{ display: 'flex', gap: SPACE.sm, marginTop: SPACE.md, marginBottom: SPACE.md }}>
        <textarea value={newText} onChange={e => setNewText(e.target.value)}
          placeholder="Nový bod (Cmd+Enter = pridať)" rows={2}
          onKeyDown={e => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) pridaj() }}
          style={{
            flex: 1, padding: '8px 10px', border: `1px solid ${COLORS.line}`,
            borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontFamily: 'inherit',
            resize: 'vertical', boxSizing: 'border-box',
          }} />
        <button onClick={pridaj} style={{
          padding: '8px 16px', background: COLORS.add, color: '#fff',
          border: 'none', borderRadius: RADIUS.sm, cursor: 'pointer',
          fontWeight: TYPO.weights.bold, fontFamily: 'inherit', alignSelf: 'flex-start',
        }}>+ Pridať</button>
      </div>

      {/* Zoznam bodov */}
      {loading ? (
        <div style={{ padding: SPACE.lg, color: COLORS.muted }}>Načítavam…</div>
      ) : items.length === 0 ? (
        <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center',
          background: COLORS.bgSoft, borderRadius: RADIUS.sm }}>
          Žiadne body v <strong>{activeTrade.label} → {activeCat.label}</strong>. Pridaj prvý.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.xs }}>
          {items.map((it, idx) => (
            <div key={it.id}
              draggable
              onDragStart={(e) => { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(it.id)); }}
              onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move' }}
              onDrop={async (e) => {
                e.preventDefault()
                const draggedId = Number(e.dataTransfer.getData('text/plain'))
                if (!draggedId || draggedId === it.id) return
                const reordered = [...items]
                const from = reordered.findIndex(x => x.id === draggedId)
                const to = reordered.findIndex(x => x.id === it.id)
                if (from < 0 || to < 0) return
                const [moved] = reordered.splice(from, 1)
                reordered.splice(to, 0, moved)
                setItems(reordered)
                try {
                  const rr = await fetchAuth('/api/vop-items/reorder', {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ids: reordered.map(x => x.id) }),
                  })
                  if (!rr.ok) throw new Error(await vopChyba(rr))
                  toast.success('Poradie zmenené')
                } catch (err) { toast.error('Chyba: ' + err.message); nacitaj() }
              }}
              style={{
                padding: SPACE.sm, background: it.active ? COLORS.bg : COLORS.bgSoft,
                border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
                borderLeft: `4px solid ${it.active ? COLORS.add : COLORS.disabled}`,
                opacity: it.active ? 1 : 0.6,
                display: 'flex', gap: SPACE.sm, alignItems: 'flex-start', cursor: 'move',
              }}>
              <span title="Ťahaj pre zmenu poradia" style={{ color: COLORS.muted, fontSize: 16, cursor: 'grab', userSelect: 'none' }}>⋮⋮</span>
              {/* Číslo zobrazené len ak je kategória 'numbered: true' */}
              <span style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: activeCat.numbered ? COLORS.brand : COLORS.muted, minWidth: 28, fontWeight: TYPO.weights.bold }}>
                {activeCat.numbered ? `${idx + 1}.` : '•'}
              </span>
              <textarea defaultValue={it.text} rows={Math.max(2, Math.ceil(it.text.length / 80))}
                onBlur={e => { if (e.target.value !== it.text) uloz(it, { text: e.target.value }) }}
                style={{
                  flex: 1, border: 'none', background: 'transparent',
                  fontSize: TYPO.sizes.sm, fontFamily: 'inherit', resize: 'vertical',
                }} />
              <button onClick={() => uloz(it, { active: it.active ? 0 : 1 })}
                title={it.active ? 'Vypnúť (nebude v PDF)' : 'Zapnúť'}
                style={{
                  padding: '4px 10px', background: 'transparent',
                  color: it.active ? COLORS.add : COLORS.muted,
                  border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
                  cursor: 'pointer', fontSize: TYPO.sizes.xs,
                }}>{it.active ? '✓ aktívne' : '○ vypnuté'}</button>
              <button onClick={() => zmaz(it.id)} title="Zmazať"
                style={{
                  padding: '4px 10px', background: 'transparent', color: COLORS.remove,
                  border: 'none', cursor: 'pointer', fontSize: TYPO.sizes.sm,
                }}>✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// ── SMS predlohy (Mirko 22.7.: „presety ti dám ja — musia byť editovateľné a pridávateľné") ──
// Premenné {stavba} {datum} {meno} {telefon} sa pri použití doplnia z kontextu (Rozpis, dopyt…).
function SmsPredlohyTab() {
  const [rows, setRows] = React.useState(null)
  const [novy, setNovy] = React.useState({ nazov: '', text: '' })
  const load = React.useCallback(() => { fetchAuth('/api/sms/presety').then(r => r.json()).then(setRows).catch(() => setRows([])) }, [])
  React.useEffect(() => { load() }, [load])
  const save = async (r) => {
    try { const res = await fetchAuth('/api/sms/presety/' + r.id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(r) }); if (!res.ok) throw new Error(); load() }
    catch (_) { alert('Uloženie zlyhalo') }
  }
  const del = async (r) => { if (!window.confirm('Zmazať predlohu „' + r.nazov + '"?')) return; try { await fetchAuth('/api/sms/presety/' + r.id, { method: 'DELETE' }); load() } catch (_) {} }
  const add = async () => {
    if (!novy.nazov.trim() || !novy.text.trim()) { alert('Vyplň názov aj text.'); return }
    try { const res = await fetchAuth('/api/sms/presety', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(novy) }); if (!res.ok) throw new Error(); setNovy({ nazov: '', text: '' }); load() }
    catch (_) { alert('Pridanie zlyhalo') }
  }
  const inp = { width: '100%', padding: '8px 10px', border: '1px solid #d6dde6', borderRadius: 8, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box' }
  const gsm = (t) => String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').length
  return (
    <div style={{ maxWidth: 760 }}>
      <div style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
        Predlohy sa ponúkajú pri každom písaní SMS (dopyt, rozpis, SMS centrum…). Premenné <b>{'{stavba}'} {'{datum}'} {'{meno}'} {'{telefon}'}</b> sa doplnia automaticky podľa toho, odkiaľ SMS píšeš. Píš bez diakritiky (brána ju aj tak odstráni) a drž sa do 160 znakov = 1 SMS.
      </div>
      {rows === null ? <div style={{ color: '#94a3b8' }}>Načítavam…</div> : rows.map(r => (
        <div key={r.id} style={{ border: '1px solid #eef2f7', borderRadius: 10, padding: 12, marginBottom: 10, background: '#fff' }}>
          <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
            <input value={r.nazov} onChange={e => setRows(list => list.map(x => x.id === r.id ? { ...x, nazov: e.target.value } : x))} style={{ ...inp, fontWeight: 700, width: 260 }} />
            <span style={{ marginLeft: 'auto', fontSize: 11, color: gsm(r.text) > 160 ? '#dc2626' : '#94a3b8', alignSelf: 'center', whiteSpace: 'nowrap' }}>{gsm(r.text)}/160</span>
          </div>
          <textarea value={r.text} onChange={e => setRows(list => list.map(x => x.id === r.id ? { ...x, text: e.target.value } : x))} rows={2} style={{ ...inp, resize: 'vertical' }} />
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 6 }}>
            <button onClick={() => del(r)} style={{ padding: '6px 12px', border: '1px solid #fecaca', background: '#fff', color: '#dc2626', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 600 }}>Zmazať</button>
            <button onClick={() => save(r)} style={{ padding: '6px 14px', border: 'none', background: '#16a34a', color: '#fff', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 700 }}>Uložiť</button>
          </div>
        </div>
      ))}
      <div style={{ border: '1px dashed #cbd5e1', borderRadius: 10, padding: 12, background: '#f8fafc' }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: '#475569', marginBottom: 6 }}>+ Nová predloha</div>
        <input value={novy.nazov} onChange={e => setNovy(s => ({ ...s, nazov: e.target.value }))} placeholder="Názov (napr. Dovoz materiálu)" style={{ ...inp, width: 260, marginBottom: 6 }} />
        <textarea value={novy.text} onChange={e => setNovy(s => ({ ...s, text: e.target.value }))} rows={2} placeholder="Text SMS… (premenné {stavba} {datum} {meno})" style={{ ...inp, resize: 'vertical' }} />
        <div style={{ textAlign: 'right', marginTop: 6 }}>
          <button onClick={add} style={{ padding: '7px 16px', border: 'none', background: '#D85A30', color: '#fff', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700, fontSize: 12.5 }}>Pridať</button>
        </div>
      </div>
    </div>
  )
}


// ══════════ ODOSLANÁ POŠTA (Mirko 11.8.) — história všetkých e-mailov z Matrixu + prílohy ══════════
function OdoslanaPostaTab() {
  const toast = useToast()
  const [data, setData] = useState(null)
  const [q, setQ] = useState('')
  useEffect(() => { fetchAuth('/api/odoslana-posta').then(r => r.json()).then(setData).catch(() => setData({ rows: [], spolu: 0 })) }, [])
  const rows = (data && data.rows || []).filter(r => !q.trim() || hladaj((r.typ + ' ' + r.cislo + ' ' + r.vec + ' ' + r.komu + ' ' + r.kto), q.trim().toLowerCase()))
  const dt = s => String(s || '').slice(0, 16).replace('T', ' ')
  const priloha = async (r) => {
    try {
      const resp = await fetchAuth(r.priloha.u, r.priloha.m === 'POST' ? { method: 'POST', body: '{}' } : undefined)
      if (!resp.ok) { toast.error('Prílohu sa nepodarilo vygenerovať (' + resp.status + ')'); return }
      const url = URL.createObjectURL(await resp.blob())
      window.open(url, '_blank'); setTimeout(() => URL.revokeObjectURL(url), 60000)
    } catch (_) { toast.error('Prílohu sa nepodarilo otvoriť.') }
  }
  if (!data) return <div style={{ color: COLORS.muted, padding: SPACE.lg }}>Načítavam…</div>
  return (
    <div>
      <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, marginBottom: 10, lineHeight: 1.6 }}>
        Každé odoslanie dokumentu z Matrixu (CP, objednávka, vyúčtovanie, dokument, protokol, výplatný list…). Príloha = PDF presne tak, ako odišlo (odoslané doklady sú zamknuté).
        Originály e-mailov aj s prílohami sú navyše v schránke <b>{data.schranka}</b> v priečinku <b>Odoslané</b>.
      </div>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Hľadať — typ, číslo, stavba, komu, kto… (napr. Bela)"
        style={{ width: '100%', maxWidth: 420, padding: '8px 11px', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm, fontFamily: 'inherit', fontSize: TYPO.sizes.sm, marginBottom: 10, boxSizing: 'border-box' }} />
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 6 }}>{rows.length} z {data.spolu} odoslaní</div>
      <div style={{ overflow: 'auto', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.md }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <thead><tr style={{ background: COLORS.bgSoft }}>
            {['Kedy', 'Typ', 'Číslo', 'Stavba / vec', 'Komu', 'Poslal', 'Príloha'].map((h, i) =>
              <th key={i} style={{ textAlign: 'left', padding: '6px 9px', borderBottom: '1px solid ' + COLORS.line, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', color: COLORS.muted, whiteSpace: 'nowrap' }}>{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} style={{ background: i % 2 ? COLORS.bgSoft : 'transparent' }}>
                <td style={{ padding: '5px 9px', whiteSpace: 'nowrap', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs }}>{dt(r.kedy)}</td>
                <td style={{ padding: '5px 9px', whiteSpace: 'nowrap', fontWeight: 600 }}>{r.typ}</td>
                <td style={{ padding: '5px 9px', whiteSpace: 'nowrap', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs }}>{r.cislo}</td>
                <td style={{ padding: '5px 9px', maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.vec}>{r.vec}</td>
                <td style={{ padding: '5px 9px', whiteSpace: 'nowrap' }}>{r.komu || '—'}</td>
                <td style={{ padding: '5px 9px', whiteSpace: 'nowrap', color: COLORS.muted }}>{r.kto || '—'}</td>
                <td style={{ padding: '5px 9px' }}>{r.priloha
                  ? <BtnGhost style={{ fontSize: TYPO.sizes.xs, padding: '2px 10px' }} onClick={() => priloha(r)}>PDF</BtnGhost>
                  : <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}>v schránke</span>}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7} style={{ padding: 16, color: COLORS.muted }}>Nič nenájdené.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  )
}

// ══════════════════════════════════════════════════════════════════
// PodpisyLudi — podpisy_v1 (Mirko 14. 10. 2026)
// „vytvoris miesto nahrať aj podpis?" + „podpisy by mali byt v tabe loga a podpisy"
//
// Podpis je vec ČLOVEKA, nie firmy: na doklade sa podpisuje ten, kto zaň zodpovedá
// („Vypracoval" na ponuke, „Vystavil" na objednávke, „Obhliadku vykonal" na protokole).
// Preto tu nie je jeden firemný podpis, ale zoznam ľudí — a podpis sa drží na ich karte,
// vedľa Titulu a Funkcie, odkiaľ si podpisový blok berie meno (ústava 137).
// Kto podpis nahratý nemá, doklad vyjde len s menom a funkciou, tak ako doteraz.
// ══════════════════════════════════════════════════════════════════
function PodpisyLudi() {
  const toast = useToast()
  const [ludia, setLudia] = React.useState([])
  const [busyId, setBusyId] = React.useState(null)
  const [obnova, setObnova] = React.useState(0)   // podpis_straz_v1
  const [hladaj, setHladaj] = React.useState('')
  // podpis_funguje_v1: adresa stránky pre iPad. Je to zároveň jediné heslo tej stránky,
  // preto sa ukazuje len tu, vo vnútri Matrixu, a nikde sa nerozosiela sama.
  const [adresa, setAdresa] = React.useState(null)
  React.useEffect(() => {
    fetchAuth('/api/podpis/adresa').then(r => r.ok ? r.json() : null).then(setAdresa).catch(() => setAdresa(null))
  }, [])

  const nacitaj = React.useCallback(() => {
    fetchAuth('/api/employees')
      .then(r => r.ok ? r.json() : [])
      .then(d => { setLudia(Array.isArray(d) ? d.filter(z => z.active !== 0 && z.active !== '0') : []); setObnova(x => x + 1) })
      .catch(() => setLudia([]))
  }, [])
  React.useEffect(() => { nacitaj() }, [nacitaj])

  const nahraj = async (id, file) => {
    if (!file) return
    setBusyId(id)
    try {
      const fd = new FormData(); fd.append('podpis', file)
      const r = await fetchAuth('/api/employees/' + encodeURIComponent(id) + '/podpis', { method: 'POST', body: fd })
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || ('HTTP ' + r.status)) }
      toast.success('Podpis nahratý')
      nacitaj()
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message) } finally { setBusyId(null) }
  }
  const odpoj = async (id) => {
    setBusyId(id)
    try {
      const r = await fetchAuth('/api/employees/' + encodeURIComponent(id) + '/podpis', { method: 'DELETE' })
      if (!r.ok) throw new Error('HTTP ' + r.status)
      toast.success('Podpis odpojený od karty — súbor sa nemaže')
      nacitaj()
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message) } finally { setBusyId(null) }
  }

  const q = hladaj.trim().toLowerCase()
  const vidno = q ? ludia.filter(z => ((z.name || '') + ' ' + (z.funkcia || '') + ' ' + (z.id || '')).toLowerCase().includes(q)) : ludia
  const sPodpisom = ludia.filter(z => z.podpis_file).length

  return (
    <div style={{ marginTop: SPACE.xl, paddingTop: SPACE.lg, borderTop: `1px solid ${COLORS.line}` }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: SPACE.md, flexWrap: 'wrap', marginBottom: SPACE.sm }}>
        <h3 style={{ margin: 0 }}>Podpisy ľudí</h3>
        <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
          {sPodpisom} z {ludia.length} má nahratý podpis
        </span>
      </div>
      <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, marginBottom: SPACE.md, maxWidth: 720, lineHeight: 1.55 }}>
        Na doklade sa podpíše ten, kto je naň uvedený ako zodpovedný; pod podpisom je jeho meno a funkcia
        z karty zamestnanca. Na <b>našich dokladoch</b> (objednávka) sa podpis kreslí cez pečiatku firmy.
        Pod <b>zmluvou zamestnanca</b> ide podpis len nad jeho meno — firemná pečiatka tam nepatrí.
        Kto podpis nahratý nemá, doklad vyjde len s menom a funkciou. Najlepšie sadne priehľadné PNG.
      </div>
      {adresa && adresa.cesta && (
        <div style={{ border: `1px solid ${COLORS.line}`, borderLeft: `3px solid ${COLORS.nav}`,
          borderRadius: RADIUS.md, padding: SPACE.md, marginBottom: SPACE.md, background: COLORS.bgSoft, maxWidth: 720 }}>
          <div style={{ fontWeight: TYPO.weights.semibold, marginBottom: 4 }}>Podpisovanie na iPade</div>
          <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, lineHeight: 1.55, marginBottom: SPACE.sm }}>
            Otvor túto adresu na iPade, človek si vyberie svoje meno a podpíše sa prstom alebo perom.
            Pred podpisom sa overí PIN-om svojho konta alebo kódom z SMS na číslo z karty — kto nemá ani jedno, tomu podpis nahráš tu.
            Podpis sa objaví tu. Prepísať si ho môže {adresa.okno_opravy_min || 15} minút, kým stojí pri iPade;
            potom je uzamknutý a nahradiť ho vie už len vedenie tu v Matrixe.
            <b> Adresa je zároveň jediné heslo tej stránky</b> — posielaj ju len tomu, kto sa má podpísať.
          </div>
          <div style={{ display: 'flex', gap: SPACE.sm, alignItems: 'center', flexWrap: 'wrap' }}>
            <code style={{ fontSize: TYPO.sizes.sm, background: COLORS.bg, padding: '5px 9px',
              borderRadius: RADIUS.sm, border: `1px solid ${COLORS.line}`, wordBreak: 'break-all' }}>
              {window.location.origin + adresa.cesta}
            </code>
            <button type="button" onClick={() => {
                try { navigator.clipboard.writeText(window.location.origin + adresa.cesta); toast.success('Adresa skopírovaná') }
                catch (_) { toast.error('Nepodarilo sa skopírovať') }
              }}
              style={{ padding: '5px 10px', background: 'none', border: `1px solid ${COLORS.line}`,
                borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.sm, fontFamily: 'inherit' }}>
              Skopírovať
            </button>
            <a href={adresa.cesta} target="_blank" rel="noreferrer"
              style={{ fontSize: TYPO.sizes.sm, color: COLORS.nav }}>Otvoriť</a>
          </div>
        </div>
      )}
      <input value={hladaj} onChange={e => setHladaj(e.target.value)} placeholder="Hľadať človeka…"
        style={{ padding: '6px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
          fontSize: TYPO.sizes.sm, fontFamily: 'inherit', width: 260, marginBottom: SPACE.md }} />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: SPACE.md }}>
        {vidno.map(z => (
          <div key={z.id} style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.md, background: COLORS.bg }}>
            <div style={{ fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.base }}>
              {[z.titul, z.name].filter(Boolean).join(' ') || z.id}
            </div>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: SPACE.sm }}>
              {z.funkcia || <span style={{ color: COLORS.warn }}>funkcia nevyplnená — v podpise bude len meno</span>}
            </div>
            <div style={{ height: 76, display: 'flex', alignItems: 'center', justifyContent: 'center',
              border: `1px dashed ${COLORS.line}`, borderRadius: RADIUS.sm, marginBottom: SPACE.sm, background: COLORS.bgSoft }}>
              {z.podpis_file
                ? <PodpisNahlad id={z.id} subor={z.podpis_file + ':' + obnova} />
                : <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}>— bez podpisu —</span>}
            </div>
            <div style={{ display: 'flex', gap: SPACE.sm, alignItems: 'center' }}>
              <label style={{ display: 'inline-block' }}>
                <span style={{ display: 'inline-block', padding: '5px 11px', background: COLORS.nav, color: '#fff',
                  borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.sm }}>
                  {busyId === z.id ? 'Nahrávam…' : (z.podpis_file ? 'Nahradiť…' : 'Nahrať podpis…')}
                </span>
                <input type="file" accept="image/*" disabled={busyId === z.id}
                  onChange={e => nahraj(z.id, e.target.files?.[0])} style={{ display: 'none' }} />
              </label>
              {z.podpis_file && (
                <button type="button" onClick={() => odpoj(z.id)} disabled={busyId === z.id}
                  style={{ padding: '5px 10px', background: 'none', border: `1px solid ${COLORS.line}`,
                    borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.sm, color: COLORS.muted, fontFamily: 'inherit' }}>
                  Odpojiť
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      {vidno.length === 0 && (
        <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm, padding: SPACE.md }}>
          {ludia.length === 0 ? 'Zoznam ľudí sa nenačítal.' : 'Nikto taký tu nie je.'}
        </div>
      )}
    </div>
  )
}

// podpis_straz_v1 (19. 10. 2026): obrázok podpisu už nie je verejný v /uploads — <img src> nenesie prihlásenie,
// preto sa načíta cez fetchAuth z prihlásenej trasy a ukáže sa ako blob. Server pustí len vedenie alebo človeka samého.
function PodpisNahlad({ id, subor }) {
  const [url, setUrl] = React.useState(null)
  const [chyba, setChyba] = React.useState(false)
  React.useEffect(() => {
    let zivy = true, u = null
    setChyba(false); setUrl(null)
    fetchAuth('/api/employees/' + encodeURIComponent(id) + '/podpis/obrazok')
      .then(r => r.ok ? r.blob() : Promise.reject(new Error('HTTP ' + r.status)))
      .then(b => { if (!zivy) return; u = URL.createObjectURL(b); setUrl(u) })
      .catch(() => { if (zivy) setChyba(true) })
    return () => { zivy = false; if (u) URL.revokeObjectURL(u) }
  }, [id, subor])
  if (chyba) return <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}>podpis je nahratý — náhľad len pre vedenie</span>
  if (!url) return <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}>načítavam…</span>
  return <img src={url} alt="" style={{ maxHeight: 68, maxWidth: '100%' }} />
}

// ── cp_katalog_v1 (Mirko 20. 10. 2026): miesto na katalógy referencií (príloha k e-mailu CP) ──
// Nahrá admin alebo office; nový súbor nahradí starý (starý ostane na serveri s dátumom). Zaškrtáva sa v okne Poslať CP.
function KatalogyReferencii() {
  const [s, setS] = useState({})
  const [busy, setBusy] = useState('')
  const toast = useToast()
  const nacitaj = () => getAllSettings().then(d => setS(d || {}))
  useEffect(() => { nacitaj() }, [])
  const info = (k) => { if (!s['katalog_' + k]) return null; try { return JSON.parse(s['katalog_' + k + '_info'] || '{}') } catch (_) { return {} } }
  async function nahraj(k, file) {
    if (!file) return
    if (!/\.pdf$/i.test(file.name)) { toast.error('Katalóg musí byť PDF.'); return }
    setBusy(k)
    try {
      const fd = new FormData(); fd.append('katalog', file)
      const r = await fetchAuth('/api/company-settings/katalog/' + k, { method: 'POST', body: fd })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(d.error || ('HTTP ' + r.status))
      toast.success('Katalóg nahratý.')
      await nacitaj()
    } catch (e) { toast.error('Nenahralo sa: ' + (e.message || e)) }
    finally { setBusy('') }
  }
  // cp_katalog_v2: okno sa otvori HNED pri kliknuti (Safari inak blokuje okno otvorene az po stiahnuti)
  async function otvor(k) {
    const w = window.open('', '_blank')
    if (!w) { toast.error('Prehliadač zablokoval nové okno — povoľ vyskakovacie okná pre Matrix.'); return }
    try {
      const r = await fetchAuth('/api/company-settings/katalog/' + k)
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || ('HTTP ' + r.status)) }
      const url = URL.createObjectURL(await r.blob())
      w.location.href = url
      setTimeout(() => URL.revokeObjectURL(url), 60000)
    } catch (e) { try { w.close() } catch (_) {} toast.error('Neotvorilo sa: ' + (e.message || e)) }
  }
  const DRUHY = [['omietky', 'Omietky'], ['potery', 'Potery']]
  const { user: _u } = useAuth()
  const smieNahrat = ['admin', 'office_manager'].includes(_u && _u.role)   // cp_katalog_v2: rovnako ako stráž na serveri
  return (
    <div style={{ marginTop: SPACE.lg }}>
      <h3 style={{ margin: 0, marginBottom: SPACE.xs }}>Katalógy referencií (príloha k e-mailu cenovej ponuky)</h3>
      <p style={{ marginTop: 0, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
        Pri odosielaní CP sa dajú zaškrtnúť a odídu zákazníkovi spolu s ponukou. PDF najviac 15 MB; nad 10 MB ho niektoré schránky neprijmú.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
        {DRUHY.map(([k, nazov]) => {
          const inf = info(k)
          const mb = inf && inf.velkost ? inf.velkost / 1048576 : 0
          return (
            <div key={k} style={{ padding: SPACE.md, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, background: COLORS.bgSoft }}>
              <div style={{ fontWeight: TYPO.weights.semibold, marginBottom: SPACE.xs }}>Katalóg referencií — {nazov}</div>
              <div style={{ fontSize: TYPO.sizes.sm, color: inf ? COLORS.text : COLORS.muted, marginBottom: SPACE.sm, minHeight: 36 }}>
                {inf
                  ? <>{inf.meno || 'katalóg.pdf'} · {mb.toFixed(1).replace('.', ',')} MB{inf.kedy ? ' · nahraté ' + new Date(inf.kedy).toLocaleDateString('sk-SK') : ''}{inf.kto ? ' (' + (inf.kto === 'cp_katalog_v1' ? 'vložené pri nasadení' : inf.kto) + ')' : ''}
                      {mb > 10 && <div style={{ color: COLORS.remove }}>Súbor je väčší ako 10 MB — niektoré schránky ho neprijmú.</div>}</>
                  : '— nenahraté —'}
              </div>
              <div style={{ display: 'flex', gap: SPACE.sm, flexWrap: 'wrap' }}>
                {smieNahrat && <label>
                  <span style={{ display: 'inline-block', padding: '6px 12px', background: COLORS.nav, color: '#fff', borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.sm }}>
                    {busy === k ? 'Nahrávam…' : (inf ? 'Nahradiť PDF…' : 'Nahrať PDF…')}
                  </span>
                  <input type="file" accept="application/pdf,.pdf" disabled={!!busy}
                    onChange={e => { nahraj(k, e.target.files?.[0]); e.target.value = '' }} style={{ display: 'none' }} />
                </label>}
                {inf && <BtnGhost onClick={() => otvor(k)}>Otvoriť</BtnGhost>}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
